// extracted by mini-css-extract-plugin
export default {"wrapper":"SA-z","viewport":"TA-z","container":"UA-z","slide":"VA-z"};